import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewEncapsulation } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { AudioPlayerService } from "./audio-player.service";
import { MatIconModule } from "@angular/material/icon";
import { NgClass, NgStyle } from "@angular/common";
import { SecondsToMinutesPipe } from "app/shared/pipes/seconds-to-minutes.pipe";

@Component({
    selector: 'audio-player',
    templateUrl: './audio-player.component.html',
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgStyle,
        NgClass,
        MatIconModule,
        SecondsToMinutesPipe
    ]
})
export class AudioPlayerComponent implements OnInit, OnDestroy, OnChanges {
    @Input() src;
    @Input() id;
    @Input() next;
    @Input() fromMe: boolean = false;

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private playerService: AudioPlayerService
    ) {}

    isPlaying = false;
    totalTime = 0;
    currentTime = 0;
    progress;
    transitionTime = 0;
    audio: HTMLAudioElement;
    toogleAudio = false;
    rate = 1.0;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    ngOnInit() {
        this.onLoad();

        this.playerService.selectedPlayer$.pipe(takeUntil(this._unsubscribeAll)).subscribe((value) => {
            if(this.src && this.src.includes('http')){
                if(this.isPlaying && this.id != value){
                    this.playPause();
                } else if (this.id == value) {
                    this.playPause();
                }
            }
        });
    }

    onLoad(){
        if(this.src && this.src.includes('http')){
            this.audio = new Audio(this.src);

            this.audio.onloadeddata = ()=>{
                this.totalTime = Math.floor(this.audio.duration);

                // if(localStorage.getItem('audioPlaybackRate')){
                //     this.rate = +(localStorage.getItem('audioPlaybackRate'));
                //     this.audio.playbackRate = this.rate;
                // }

                this._changeDetectorRef.markForCheck();
            }

            this.audio.onended = ()=>{
                this.audio.pause();
                this.isPlaying = false;

                if(this.next){
                    this.playerService.setPlayer(this.next);
                }

                this._changeDetectorRef.markForCheck();
            }
        }else{
            this.audio = new Audio();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes?.src && changes?.src?.currentValue && changes.src.currentValue.includes('http')){
            this.onLoad()
        }
    }

    setPlayer(){
        this.playerService.setPlayer(this.id)
    }

    ngOnDestroy() {
        this.playerService.setPlayer(null);
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    playPause(){
        // if(localStorage.getItem('audioPlaybackRate')){
        //     this.rate = +(localStorage.getItem('audioPlaybackRate'));
        //     this.audio.playbackRate = +(localStorage.getItem('audioPlaybackRate'));
        // }

        if(this.isPlaying){
            this.audio.pause();
            this._changeDetectorRef.markForCheck();
        }else{
            if(this.audio){
                this.audio.play();
            }

            this.audio.ontimeupdate = (event) => {
                this.currentTime = this.audio.currentTime;
                this.progress = this.currentTime / this.totalTime * 100 + "%";
                this._changeDetectorRef.markForCheck();
            }

            this._changeDetectorRef.markForCheck();
        }

        this.isPlaying = !this.isPlaying;
    }

    setSeek(event){
        this.audio.currentTime = event.target.value;
        this.currentTime = this.audio.currentTime;
        this._changeDetectorRef.markForCheck();
    }

    setPlaybackRate(e){
        switch (e) {
            case 1.0:
                this.rate = 1.5;
            break;
            case 1.5:
                this.rate = 2.0;
            break;
            case 2.0:
                this.rate = 1.0;
            break;
            default:
                this.rate = 1.0;
            break;
        }
        // this.audio.playbackRate = this.rate;
        // localStorage.setItem('audioPlaybackRate', (this.rate).toString());
    }
}
